<div class="app-text-input">
  <label *ngIf="label" class="app-text-input__label" [attr.for]="id">{{ label }}</label>

  <div class="app-text-input__field">
    <img
      *ngIf="startIcon"
      class="app-text-input__icon app-text-input__icon--start"
      [src]="startIcon"
      [alt]="startIconAlt"
    />

    <input
      class="form-control app-text-input__control"
      [ngClass]="[
        inputClass,
        showError ? 'error-field' : '',
        startIcon ? 'app-text-input__control--with-start-icon' : '',
        (endIcon || (enablePasswordToggle && type === 'password')) ? 'app-text-input__control--with-end-icon' : ''
      ]"
      [attr.type]="resolvedType"
      [attr.id]="id"
      [attr.name]="name || id"
      [attr.placeholder]="placeholder"
      [attr.aria-label]="ariaLabel || placeholder"
      [attr.autocomplete]="autocomplete"
      [attr.min]="min"
      [attr.max]="max"
      [attr.step]="step"
      [attr.inputmode]="inputMode"
      [disabled]="disabled"
      [value]="value"
      (input)="inputChanged($event)"
      (blur)="onTouched()"
    />

    <img
      *ngIf="endIcon"
      class="app-text-input__icon app-text-input__icon--end"
      [src]="endIcon"
      [alt]="endIconAlt"
    />

    <button
      *ngIf="enablePasswordToggle && type === 'password'"
      type="button"
      class="app-text-input__toggle"
      [disabled]="disabled"
      [attr.aria-label]="isPasswordVisible ? 'Hide password' : 'Show password'"
      (click)="togglePasswordVisibility()">
      <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.00033 0.5C4.66699 0.5 1.82033 2.57333 0.666992 5.5C1.82033 8.42667 4.66699 10.5 8.00033 10.5C11.3337 10.5 14.1803 8.42667 15.3337 5.5C14.1803 2.57333 11.3337 0.5 8.00033 0.5ZM8.00033 8.83333C6.16033 8.83333 4.66699 7.34 4.66699 5.5C4.66699 3.66 6.16033 2.16667 8.00033 2.16667C9.84032 2.16667 11.3337 3.66 11.3337 5.5C11.3337 7.34 9.84032 8.83333 8.00033 8.83333ZM8.00033 3.5C6.89366 3.5 6.00033 4.39333 6.00033 5.5C6.00033 6.60667 6.89366 7.5 8.00033 7.5C9.10699 7.5 10.0003 6.60667 10.0003 5.5C10.0003 4.39333 9.10699 3.5 8.00033 3.5Z"
          [ngClass]="{ 'fill-active': isPasswordVisible, 'fill-default': !isPasswordVisible }" />
      </svg>
    </button>
  </div>

  <span *ngIf="showError && errorMessage" class="error-text">{{ errorMessage }}</span>
</div>
